let collectionData = document.querySelector("[data-product-json]");
let products = JSON.parse(collectionData.textContent || "[]");
console.log("image", products[0]);
if (Array.isArray(products)) {
  products = products.map((p) => ({
    id: p.id,
    first_variant_id: p.variants[0].id,
    name: p.title,
    image: p.featured_image,
    tag:
      Array.isArray(p.tags) && p.tags.length
        ? p.tags.includes("limited-edition")
          ? "limited-edition"
          : p.tags.includes("best-selling")
            ? "best-selling"
            : null
        : null,
    profiles: p.metafields?.profiles
      ? Array.isArray(p.metafields.profiles)
        ? p.metafields.profiles.map((x) =>
          typeof x === "string" ? x.toLowerCase() : x,
        )
        : [
          typeof p.metafields.profiles === "string"
            ? p.metafields.profiles.toLowerCase()
            : p.metafields.profiles,
        ]
      : [],
    meals: p.metafields?.meals
      ? Array.isArray(p.metafields.meals)
        ? p.metafields.meals.map((x) =>
          typeof x === "string" ? x.toLowerCase() : x,
        )
        : [
          typeof p.metafields.meals === "string"
            ? p.metafields.meals.toLowerCase()
            : p.metafields.meals,
        ]
      : [],
    diets: p.metafields?.diets
      ? Array.isArray(p.metafields.diets)
        ? p.metafields.diets.map((x) =>
          typeof x === "string" ? x.toLowerCase().replace(/\s+/g, "") : x,
        )
        : [
          typeof p.metafields.diets === "string"
            ? p.metafields.diets.toLowerCase().replace(/\s+/g, "")
            : p.metafields.diets,
        ]
      : [],
    type: p.metafields?.type
      ? Array.isArray(p.metafields.type)
        ? p.metafields.type.map((x) =>
          typeof x === "string" ? x.toLowerCase() : x,
        )
        : [
          typeof p.metafields.type === "string"
            ? p.metafields.type.toLowerCase()
            : p.metafields.type,
        ]
      : [],
  }));
}

// State
let selectedProducts = new Map(); // Changed to Map to store quantities: productId -> quantity
let activeFilters = {
  type: [],
  profile: [],
  meal: [],
  diet: [],
};
let searchQuery = "";
let currentSort = "featured";
let lastToastMessage = "";
let drawerTextInterval = null;
let previousDiscountPercent = 0; // Track previous discount to animate changes

const SPECIAL_PRODUCT_ID = 424810728670493; // Variant ID
const SPECIAL_PRODUCT_PRICE = 5.00;
const SPECIAL_PRODUCT_ORIGINAL_PRICE = 10.00;

// ===== CENTRALIZED BUNDLE CONFIGURATION =====
// All pricing, discounts, and rewards are defined here for easy management
const BUNDLE_CONFIG = {
  // Base pricing
  pricing: {
    basePrice: 10.0, // Price per bottle before discounts
    giftCardValue: 10.0, // Value of free gift card reward
  },

  // Tier-based discounts (progressive per-bottle pricing)
  // 1st bottle = 0% off ($10), 2nd = 10% off ($9), 3rd = 20% off ($8), etc.
  tiers: [
    { itemCount: 1, discount: 0.0, type: "percentage", label: "0%" },
    { itemCount: 2, discount: 0.05, type: "percentage", label: "5%" },
    { itemCount: 3, discount: 0.1, type: "percentage", label: "10%" },
    { itemCount: 4, discount: 0.15, type: "percentage", label: "15%" },
    { itemCount: 5, discount: 0.2, type: "percentage", label: "20%" },
  ],

  // Rewards unlocked at specific thresholds
  rewards: [
    {
      threshold: 6,
      type: "free-shipping",
      label: "FREE SHIP",
      name: "FREE Shipping (to Lower 48 U.S.)",
      description: "Free Shipping (to Lower 48 U.S.)",
    },
    {
      threshold: 8,
      type: "rush-handling",
      value: 2.99,
      name: "FREE Rush Handling",
      label: "FREE Rush",
      description: "Jump the queue. Get your bundle faster.",
      image: "https://flavorgod.com/cdn/shop/products/32541786702019_200x.png",
    },
    {
      threshold: 10,
      type: "gift-card",
      value: 10.0,
      name: "FREE $10 Gift Card",
      label: "FREE Gift Card",
      description: "Gift someone the gift of flavor!",
      image:
        "https://flavorgod.com/cdn/shop/files/WhatsApp_Image_2025-05-26_at_19.03.03_8ca6c568.jpg?v=1762457193&width=380",
    },
    {
      threshold: 15,
      type: "gift-rack",
      value: 80.0,
      name: "FREE Spice Rack",
      label: "FREE Rack",
      description: "Store your favorite seasonings in style!",
      image:
        "https://flavorgod.com/cdn/shop/products/17987717038232.jpg?v=1762457195&width=1100",
    },
    // Future rewards can be added here:
    // { threshold: 15, type: 'free-product', sku: 'ABC123', label: 'Free Product' }
  ],
};

// Legacy constants for backward compatibility (will be removed after refactor)
const PRICE_PER_BOTTLE = BUNDLE_CONFIG.pricing.basePrice;
const GIFT_CARD_VALUE = BUNDLE_CONFIG.pricing.giftCardValue;
const FREE_SHIPPING_THRESHOLD = BUNDLE_CONFIG.rewards.find(
  (r) => r.type === "free-shipping",
).threshold;
const GIFT_CARD_THRESHOLD = BUNDLE_CONFIG.rewards.find(
  (r) => r.type === "gift-card",
).threshold;

// ===== BUNDLE CONFIG HELPER FUNCTIONS =====
// These functions abstract access to the configuration for easier maintenance

/**
 * Get the tier information for a given item count
 * @param {number} count - Number of items in bundle
 * @returns {object} Tier object with itemCount, discount, and label
 */
function getTierForItemCount(count) {
  // Find the highest tier that applies to this count
  // Tiers are ordered by itemCount ascending
  for (let i = BUNDLE_CONFIG.tiers.length - 1; i >= 0; i--) {
    if (count >= BUNDLE_CONFIG.tiers[i].itemCount) {
      return BUNDLE_CONFIG.tiers[i];
    }
  }
  // Return first tier (0% discount) if count is 0
  return BUNDLE_CONFIG.tiers[0];
}

/**
 * Get the discount percentage for a bottle at a specific position
 * @param {number} position - 0-indexed position (0 = 1st bottle, 1 = 2nd bottle, etc.)
 * @returns {number} Discount percentage (e.g., 0.10 for 10% off)
 */
function getDiscountForPosition(position) {
  const itemCount = position + 1; // Convert 0-indexed to 1-indexed
  const tier = getTierForItemCount(itemCount);
  return tier.discount;
}

/**
 * Get the price for a bottle at a specific position
 * @param {number} position - 0-indexed position (0 = 1st bottle, 1 = 2nd bottle, etc.)
 * @returns {number} Price for that bottle
 */
function getPriceForPosition(position) {
  const discount = getDiscountForPosition(position);
  return BUNDLE_CONFIG.pricing.basePrice * (1 - discount);
}

/**
 * Get all rewards that are active at the given item count
 * @param {number} count - Number of items in bundle
 * @returns {array} Array of active reward objects
 */
function getActiveRewards(count) {
  return BUNDLE_CONFIG.rewards.filter((reward) => count >= reward.threshold);
}

/**
 * Get the next reward milestone that hasn't been reached yet
 * @param {number} count - Current number of items in bundle
 * @returns {object|null} Next reward object, or null if all rewards unlocked
 */
function getNextMilestone(count) {
  const nextReward = BUNDLE_CONFIG.rewards.find(
    (reward) => count < reward.threshold,
  );
  return nextReward || null;
}

/**
 * Get all tier discount percentages as an array
 * @returns {array} Array of discount percentages [10, 20, 30, 40]
 */
function getAllTierDiscounts() {
  // Skip first tier (0% discount) and return percentages as whole numbers
  return BUNDLE_CONFIG.tiers.slice(1).map((tier) => tier.discount * 100);
}

/**
 * Get the number of items needed to reach the next tier
 * @param {number} count - Current number of items
 * @returns {number|null} Items needed for next tier, or null if at max tier
 */
function getItemsToNextTier(count) {
  const currentTier = getTierForItemCount(count);
  const currentTierIndex = BUNDLE_CONFIG.tiers.indexOf(currentTier);

  if (currentTierIndex < BUNDLE_CONFIG.tiers.length - 1) {
    const nextTier = BUNDLE_CONFIG.tiers[currentTierIndex + 1];
    return nextTier.itemCount - count;
  }

  return null; // Already at max tier
}

// Pricing Calculation Functions
function calculatePricing() {
  let totalItemCount = 0;
  let specialItemCount = 0;

  selectedProducts.forEach((quantity, productId) => {
    totalItemCount += quantity;
    if (Number(productId) === SPECIAL_PRODUCT_ID) {
      specialItemCount += quantity;
    }
  });

  const normalItemCount = totalItemCount - specialItemCount;

  // Subtotal (Original Prices)
  const subtotal = (normalItemCount * BUNDLE_CONFIG.pricing.basePrice) + (specialItemCount * SPECIAL_PRODUCT_ORIGINAL_PRICE);

  // Determine applicable tier for the current count
  const currentTier = getTierForItemCount(totalItemCount);
  const tierDiscount = currentTier ? currentTier.discount : 0;

  // Normal items get the tier discount, special items get fixed price
  const normalItemsTotal = (normalItemCount * BUNDLE_CONFIG.pricing.basePrice) * (1 - tierDiscount);
  const specialItemsTotal = (specialItemCount * SPECIAL_PRODUCT_PRICE);

  const total = normalItemsTotal + specialItemsTotal;
  const discountAmount = subtotal - total;
  const discountPercent = totalItemCount > 0 ? tierDiscount : 0;

  const hasFreeShipping = totalItemCount >= FREE_SHIPPING_THRESHOLD;
  const hasGiftCard = totalItemCount >= GIFT_CARD_THRESHOLD;

  return {
    subtotal,
    discountPercent,
    discountAmount,
    hasFreeShipping,
    hasGiftCard,
    total,
  };
}

function formatPrice(amount) {
  return `$${amount.toFixed(2)}`;
}

// Toast Messages Configuration - Easily customizable!
// Positive reinforcement words - randomly selected
const positiveWords = [
  "Nice!",
  "Great!",
  "Awesome!",
  "Amazing!",
  "Perfect!",
  "Excellent!",
  "Fantastic!",
];

/**
 * Dynamically generate toast message based on current item count
 * @param {number} itemCount - Current number of items in bundle
 * @returns {string} Toast message for this item count
 */
function getToastMessage(itemCount) {
  const nextBottleCount = itemCount + 1;
  const currentTier = getTierForItemCount(itemCount);
  const nextTier = getTierForItemCount(nextBottleCount);
  const activeRewards = getActiveRewards(itemCount);
  const nextRewards = getActiveRewards(nextBottleCount);

  // Check if we just unlocked a new reward
  const newReward = nextRewards.find((r) => !activeRewards.includes(r));

  if (newReward) {
    // Unlocked any reward - use its label
    return `${newReward.label} unlocked! 🎉`;
  }

  // Check if next bottle unlocks a new tier
  if (nextTier.discount > currentTier.discount) {
    const nextDiscountPercent = Math.round(nextTier.discount * 100);
    const nextBottleWillUnlockShipping =
      nextBottleCount >= FREE_SHIPPING_THRESHOLD;

    if (nextBottleWillUnlockShipping && itemCount < FREE_SHIPPING_THRESHOLD) {
      return `Add 1 more at ${nextDiscountPercent}% off!`;
    } else {
      return `Add another at ${nextDiscountPercent}% off!`;
    }
  }

  // At max tier - check for upcoming rewards
  const currentDiscountPercent = Math.round(currentTier.discount * 100);

  // Check if next item unlocks any reward
  const upcomingReward = BUNDLE_CONFIG.rewards.find(
    (r) => nextBottleCount === r.threshold,
  );
  if (upcomingReward) {
    return `Add 1 more for ${upcomingReward.label}!`;
  }

  // Show active rewards
  if (activeRewards.length > 0) {
    const rewardLabels = activeRewards.map((r) => r.label).join(" + ");

    // Check if we just hit the threshold for first reward
    const justUnlocked = activeRewards.some((r) => itemCount === r.threshold);
    if (justUnlocked) {
      return `${currentDiscountPercent}% Off + ${rewardLabels} unlocked! 🎉`;
    }

    return `${currentDiscountPercent}% Off + ${rewardLabels}!`;
  }

  // Default message
  return `${currentDiscountPercent}% Off!`;
}

// DOM Elements
const productsGrid = document.getElementById("productsGrid");
const bundleBar = document.getElementById("bundleBar");
const checkoutBtn = document.getElementById("checkoutBtn");
const desktopSearchInput = document.getElementById("desktopSearchInput");
const mobileSearchInput = document.getElementById("mobileSearchInput");
const mobileSearchBar = document.getElementById("mobileSearchBar");
const mobileSearchBtn = document.getElementById("mobileSearchBtn");
const mobileSearchClose = document.getElementById("mobileSearchClose");
const clearFiltersBtn = document.getElementById("clearFilters");
const applyFiltersBtn = document.getElementById("applyFilters");
const mobileFilterBtn = document.getElementById("mobileFilterBtn");
const mobileSortBtn = document.getElementById("mobileSortBtn");
const filterSidebar = document.getElementById("filterSidebar");
const closeFiltersBtn = document.getElementById("closeFilters");
const filterOverlay = document.getElementById("filterOverlay");
const noResults = document.getElementById("noResults");
const filterBadgesContainer = document.getElementById("filterBadges");
const sortSelect = document.getElementById("sortSelect");
const sortModal = document.getElementById("sortModal");
const closeSortModal = document.getElementById("closeSortModal");
const bundleDrawer = document.getElementById("bundleDrawer");
const drawerHandle = document.getElementById("drawerHandle");
const drawerClose = document.getElementById("drawerClose");
const drawerProducts = document.getElementById("drawerProducts");
const drawerSubtotal = document.getElementById("drawerSubtotal");
const drawerDiscount = document.getElementById("drawerDiscount");
const drawerDiscountLabel = document.getElementById("drawerDiscountLabel");
const drawerDiscountRow = document.getElementById("drawerDiscountRow");
const drawerGiftCard = document.getElementById("drawerGiftCard");
const drawerGiftCardRow = document.getElementById("drawerGiftCardRow");
const drawerTotal = document.getElementById("drawerTotal");
const drawerFreeShippingRow = document.getElementById("drawerFreeShippingRow");
const tierModal = document.getElementById("tierModal");
const tierModalClose = document.getElementById("tierModalClose");
const tierModalMessage = document.getElementById("tierModalMessage");
const tierCurrentTotal = document.getElementById("tierCurrentTotal");
const tierContinueBtn = document.getElementById("tierContinueBtn");
const tierAddMoreBtn = document.getElementById("tierAddMoreBtn");
const tierRecommendations = document.getElementById("tierRecommendations");

// Filter label mappings
const filterLabels = {
  type: {
    seasonings: "Seasonings",
    toppers: "Toppers",
    rubs: "Rubs & Finisher Salts",
  },
  profile: {
    savory: "Savory",
    sweet: "Sweet",
    spicy: "Spicy",
    tangy: "Tangy",
  },
  meal: {
    beef: "Beef",
    burgers: "Burgers",
    chicken: "Chicken",
    coffee: "Coffee",
    dips: "Dips",
    dressings: "Dressings",
    eggs: "Eggs",
    oatmeal: "Oatmeal",
    pasta: "Pasta",
    popcorn: "Popcorn",
    pork: "Pork",
    potatoes: "Potatoes",
    salad: "Salad",
    sauces: "Sauces",
    seafood: "Seafood",
    shrimp: "Shrimp",
    smoothies: "Smoothies",
    steaks: "Steaks",
    tofu: "Tofu",
  },
  diet: {
    "0carbs": "0 Carbs",
    "0fat": "0 Fat",
    dairyfree: "Dairy Free",
    glutenfree: "Gluten Free",
    keto: "Keto",
    kosher: "Kosher",
    lowsodium: "Low Sodium",
    nofillers: "No Fillers",
    nomsg: "No Msg",
    nosugar: "No Sugar",
    nongmo: "Non GMO",
    paleo: "Paleo",
    vegan: "Vegan",
  },
};

// Initialize
/**
 * Initialize tier badges dynamically from BUNDLE_CONFIG
 * Uses circular number style matching header benefits for visual continuity
 */
function initializeTierBadges() {
  const tierProgress = document.getElementById("bundleTierProgress");
  const freeShipBadge = document.getElementById("bundleFreeShip");

  // Clear existing badges (except FREE SHIP)
  const existingBadges = tierProgress.querySelectorAll(".tier-badge-step");
  existingBadges.forEach((badge) => badge.remove());

  // Generate badges from config (skip first tier which is 0%)
  // Use circular number style matching header benefits
  const tierBadges = BUNDLE_CONFIG.tiers.slice(1).map((tier) => {
    const badgeContainer = document.createElement("div");
    badgeContainer.className = "tier-badge-step locked";
    badgeContainer.setAttribute("data-tier", Math.round(tier.discount * 100));
    badgeContainer.setAttribute("data-count", tier.itemCount);

    badgeContainer.innerHTML = `
            <div class="tier-badge-number">${tier.itemCount}</div>
            <div class="tier-badge-text">${tier.label} off</div>
        `;

    return badgeContainer;
  });

  // Insert badges before FREE SHIP badge
  tierBadges.forEach((badge) => {
    tierProgress.insertBefore(badge, freeShipBadge);
  });
}

/**
 * Initialize header benefits in 2x2 grid layout
 * Discounts on bottom-right, Gifts on bottom-left
 */
function initializeHeaderBenefits() {
  const headerDiscounts = document.getElementById("headerDiscounts");
  const headerGifts = document.getElementById("headerGifts");

  // Discounts section (bottom-right)
  let discountsHTML = `
        <h4 class="section-header">DISCOUNTS</h4>
        <div class="benefits-grid">
    `;

  // Add tier benefits (skip first tier which is 0%)
  BUNDLE_CONFIG.tiers.slice(1).forEach((tier, index) => {
    discountsHTML += `
            <div class="benefit-step" title="Buy ${tier.itemCount}+ bottles and save ${tier.label} per bottle">
                <div class="benefit-number">${tier.itemCount}</div>
                <div class="benefit-text">${tier.label} off</div>
            </div>
        `;
  });

  discountsHTML += "</div>";
  headerDiscounts.innerHTML = discountsHTML;

  // Gifts section (bottom-left)
  if (BUNDLE_CONFIG.rewards.length > 0) {
    let giftsHTML = `
            <h4 class="section-header section-header-gifts">
                <svg class="gift-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 12 20 22 4 22 4 12"></polyline>
                    <rect x="2" y="7" width="20" height="5"></rect>
                    <line x1="12" y1="22" x2="12" y2="7"></line>
                    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
                </svg>
                GIFTS
            </h4>
            <div class="benefits-grid">
        `;

    BUNDLE_CONFIG.rewards.forEach((reward) => {
      giftsHTML += `
                <div class="benefit-step benefit-gift" title="${reward.description}">
                    <div class="benefit-number">${reward.threshold}+</div>
                    <div class="benefit-text">${reward.name}</div>
                </div>
            `;
    });

    giftsHTML += "</div>";
    headerGifts.innerHTML = giftsHTML;
  }
}

/**
 * Syncs the bundle page state with existing Shopify cart items
 */
async function syncCartWithBundle() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    // Clear existing selections
    selectedProducts.clear();

    cart.items.forEach(item => {
      // Find if this cart item corresponds to a bundle product
      // We match by variant ID
      const product = products.find(p => p.first_variant_id === item.variant_id);

      if (product) {
        // Add to selected products with its quantity
        selectedProducts.set(product.first_variant_id, item.quantity);
      }
    });

    // Update UI components with synced data
    updateBundleBar();
    updateDrawer();

  } catch (error) {
    console.error('Error syncing cart:', error);
  }
}

async function init() {
  initializeTierBadges();
  initializeHeaderBenefits();

  // Sync with cart before rendering to ensure correct checked states
  await syncCartWithBundle();

  renderProducts(products);
  setupEventListeners();
  renderFilterBadges();
}

// Render Products
function renderProducts(productsToRender) {
  productsGrid.innerHTML = "";

  if (productsToRender.length === 0) {
    noResults.style.display = "block";
    return;
  }

  noResults.style.display = "none";

  productsToRender.forEach((product) => {
    const isAdded = selectedProducts.has(product.first_variant_id);
    const currentCount = getTotalItemCount();

    const productCard = document.createElement("div");
    productCard.className = `product-card ${isAdded ? "added" : ""}`;
    productCard.setAttribute("data-product-id", product.first_variant_id);

    let tagHTML = "";
    if (product.tag) {
      const tagLabel =
        product.tag === "best-selling"
          ? "Best Selling"
          : product.tag === "limited-edition"
            ? "Limited"
            : "New";
      tagHTML = `<div class="product-tag ${product.tag}">${tagLabel}</div>`;
    }

    const quantity = selectedProducts.get(product.first_variant_id) || 0;

    const checkboxHTML = `
            <label class="product-checkbox-wrapper">
                <input type="checkbox" class="product-checkbox" data-product-id="${product.first_variant_id}" ${isAdded ? "checked" : ""}>
                <span class="checkbox-custom"></span>
            </label>
        `;

    // Calculate next bottle price for pricing display
    // Only show pricing for unchecked items when cart has items
    const nextBottlePrice = getNextBottlePrice();
    const hasDiscount = nextBottlePrice < PRICE_PER_BOTTLE;

    // Calculate discount percentage
    const discountPercent = hasDiscount
      ? Math.round(
        ((PRICE_PER_BOTTLE - nextBottlePrice) / PRICE_PER_BOTTLE) * 100,
      )
      : 0;

    // Get all discount tiers from config
    const allTiers = getAllTierDiscounts();
    const currentTierIndex = allTiers.indexOf(discountPercent);

    const isSpecialProduct = Number(product.first_variant_id) === SPECIAL_PRODUCT_ID;

    // Show pricing for UNCHECKED items when cart has items
    const pricingHTML =
      !isAdded && currentCount > 0
        ? isSpecialProduct
          ? `
            <div class="product-pricing">
                <div class="product-pricing-row">
                    <span class="product-price-original">${formatPrice(SPECIAL_PRODUCT_ORIGINAL_PRICE)}</span>
                    <span class="product-price-current">${formatPrice(SPECIAL_PRODUCT_PRICE)}</span>
                </div>
            </div>
          `
          : `
            <div class="product-pricing">
                <div class="product-tier-badges">
                    <div class="product-tier-badges-track">
                        ${allTiers
            .map((tier) => {
              const isActive = tier === discountPercent;
              const isInactive = tier > discountPercent;
              return `
                                <span class="product-tier-badge ${isActive ? "active" : ""} ${isInactive ? "inactive" : ""}">
                                    ${tier}% Off
                                </span>
                            `;
            })
            .join("")}
                    </div>
                </div>
                <div class="product-pricing-row">
                    <span class="product-price-original">${formatPrice(PRICE_PER_BOTTLE)}</span>
                    <span class="product-price-current">${formatPrice(nextBottlePrice)}</span>
                </div>
            </div>
        `
        : "";

    // Show attribute tags for UNCHECKED items when cart is empty (max 7 tags)
    const attributesHTML =
      !isAdded && currentCount === 0
        ? (() => {
          const allTags = [
            ...product.profiles,
            ...product.meals,
            ...product.diets,
          ].slice(0, 120);
          return `
                <div class="product-attributes">
                    ${allTags.map((tag) => `<span class="attribute-tag">${tag}</span>`).join("")}
                </div>
            `;
        })()
        : "";

    // Show "Add more" pricing only (drawer shows full breakdown)
    const addedPriceHTML = isAdded
      ? isSpecialProduct
        ? `
            <div class="product-added-pricing">
                <div class="product-pricing-row" style="justify-content: center; margin-top: 4px;">
                    <span class="product-price-original">${formatPrice(SPECIAL_PRODUCT_ORIGINAL_PRICE)}</span>
                    <span class="product-price-current">${formatPrice(SPECIAL_PRODUCT_PRICE)}</span>
                </div>
            </div>
          `
        : (() => {
          const nextPrice = getNextBottlePrice();
          const currentTotalCount = getTotalItemCount();
          // Get discount for the NEXT bottle from config
          const nextBottleDiscount = getDiscountForPosition(currentTotalCount);
          const discountPercentCurrent = Math.round(nextBottleDiscount * 100);

          return discountPercentCurrent > 0
            ? `
                <div class="product-added-pricing">
                    <div class="add-more-row">
                        <span>Add more at ${formatPrice(nextPrice)}</span>
                        <span class="discount-badge">${discountPercentCurrent}% off</span>
                    </div>
                </div>
            `
            : "";
        })()
      : "";

    const controlsHTML = isAdded
      ? `
            <div class="product-quantity-controls">
                <button class="btn-quantity-minus" data-product-id="${product.first_variant_id}">−</button>
                <span class="product-quantity">${quantity}</span>
                <button class="btn-quantity-plus" data-product-id="${product.first_variant_id}">+</button>
            </div>
        `
      : "";

    productCard.innerHTML = `
            ${tagHTML}
            ${checkboxHTML}
            <img src="${product.image}" alt="${product.name}" class="product-image">
            <h3 class="product-name">${product.name}</h3>
            ${attributesHTML}
            ${pricingHTML}
            ${addedPriceHTML}
            ${controlsHTML}
        `;

    // Store current discount percent for animation detection
    if (!isAdded && currentCount > 0 && hasDiscount) {
      productCard.setAttribute("data-discount-percent", discountPercent);
    }

    productsGrid.appendChild(productCard);
  });

  // Trigger pricing animations for cards with changed discounts
  animatePricingChanges();

  // Restore scroll positions for tier badges (prevent reset on re-render)
  setTimeout(() => {
    const badgesContainers = document.querySelectorAll(".product-tier-badges");
    const currentCount = getTotalItemCount();
    const hasDiscount = currentCount > 1;

    if (hasDiscount) {
      badgesContainers.forEach((container) => {
        const activeBadge = container.querySelector(
          ".product-tier-badge.active",
        );
        if (activeBadge) {
          // Calculate scroll position to center the active badge
          const containerCenter = container.offsetWidth / 2;
          const badgeCenter =
            activeBadge.offsetLeft + activeBadge.offsetWidth / 2;
          const scrollPosition = badgeCenter - containerCenter;

          // Instantly restore position (no animation here, animation handled in animatePricingChanges)
          container.scrollLeft = scrollPosition;
        }
      });
    }
  }, 10);
}

// Animate pricing changes when discount percentage increases
function animatePricingChanges() {
  const nextBottlePrice = getNextBottlePrice();
  const hasDiscount = nextBottlePrice < PRICE_PER_BOTTLE;
  const currentDiscountPercent = hasDiscount
    ? Math.round(
      ((PRICE_PER_BOTTLE - nextBottlePrice) / PRICE_PER_BOTTLE) * 100,
    )
    : 0;

  // Only animate if discount has increased
  if (
    currentDiscountPercent > previousDiscountPercent &&
    currentDiscountPercent > 0
  ) {
    // Scroll tier badges to the next position (only when tier changes)
    setTimeout(() => {
      const badgesContainers = document.querySelectorAll(
        ".product-tier-badges",
      );
      badgesContainers.forEach((container) => {
        const activeBadge = container.querySelector(
          ".product-tier-badge.active",
        );
        if (activeBadge) {
          // Calculate scroll position to center the active badge
          const containerCenter = container.offsetWidth / 2;
          const badgeCenter =
            activeBadge.offsetLeft + activeBadge.offsetWidth / 2;
          const scrollPosition = badgeCenter - containerCenter;

          // Smooth scroll to the new position
          container.scrollTo({
            left: scrollPosition,
            behavior: "smooth",
          });
        }
      });
    }, 50);

    // Animate price popping in
    setTimeout(() => {
      const productCards = document.querySelectorAll(
        ".product-card:not(.added)",
      );
      productCards.forEach((card) => {
        const priceRow = card.querySelector(".product-pricing-row");
        if (priceRow) {
          priceRow.classList.add("pop-in-price");
          setTimeout(() => priceRow.classList.remove("pop-in-price"), 500);
        }
      });
    }, 300); // Delay price animation after tier slide completes
  }

  // Update previous discount for next comparison
  previousDiscountPercent = currentDiscountPercent;
}

// Render Filter Badges
function renderFilterBadges() {
  filterBadgesContainer.innerHTML = "";

  const hasFilters =
    activeFilters.profile.length > 0 ||
    activeFilters.meal.length > 0 ||
    activeFilters.type.length > 0 ||
    activeFilters.diet.length > 0 ||
    searchQuery;

  // Show/hide Clear All button
  if (hasFilters) {
    clearFiltersBtn.style.display = "block";
    filterBadgesContainer.style.display = "flex";
  } else {
    clearFiltersBtn.style.display = "none";
    filterBadgesContainer.style.display = "none";
    return;
  }

  // Add search badge if search is active
  if (searchQuery) {
    const badge = document.createElement("div");
    badge.className = "filter-badge";
    badge.innerHTML = `
            <span>Search: "${searchQuery}"</span>
            <button class="filter-badge-remove" data-filter-type="search">&times;</button>
        `;
    filterBadgesContainer.appendChild(badge);
  }

  // Add filter badges
  Object.keys(activeFilters).forEach((filterType) => {
    activeFilters[filterType].forEach((filterValue) => {
      const badge = document.createElement("div");
      badge.className = "filter-badge";
      badge.innerHTML = `
                <span>${filterLabels[filterType][filterValue]}</span>
                <button class="filter-badge-remove" data-filter-type="${filterType}" data-filter-value="${filterValue}">&times;</button>
            `;
      filterBadgesContainer.appendChild(badge);
    });
  });

  // Add event listeners to remove buttons
  document.querySelectorAll(".filter-badge-remove").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const filterType = e.target.dataset.filterType;
      const filterValue = e.target.dataset.filterValue;

      if (filterType === "search") {
        searchQuery = "";
        desktopSearchInput.value = "";
        mobileSearchInput.value = "";
      } else {
        removeFilter(filterType, filterValue);
      }

      filterAndSortProducts();
    });
  });
}

// Remove a single filter
function removeFilter(filterType, filterValue) {
  activeFilters[filterType] = activeFilters[filterType].filter(
    (v) => v !== filterValue,
  );

  // Uncheck the corresponding checkbox
  const checkbox = document.querySelector(
    `input[data-filter="${filterType}"][value="${filterValue}"]`,
  );
  if (checkbox) {
    checkbox.checked = false;
  }
}

// Setup Event Listeners
function setupEventListeners() {
  // Handle checkbox changes
  productsGrid.addEventListener("change", (e) => {
    if (e.target.classList.contains("product-checkbox")) {
      const productId = parseInt(e.target.dataset.productId);

      if (e.target.checked) {
        addProduct(productId);
      } else {
        removeProduct(productId);
      }
    }
  });

  // Make entire card clickable to toggle checkbox (except quantity buttons)
  productsGrid.addEventListener("click", (e) => {
    // Handle quantity button clicks first
    if (e.target.classList.contains("btn-quantity-plus")) {
      const productId = parseInt(e.target.dataset.productId);
      incrementProduct(productId);
      return; // Don't toggle checkbox
    } else if (e.target.classList.contains("btn-quantity-minus")) {
      const productId = parseInt(e.target.dataset.productId);
      decrementProduct(productId);
      return; // Don't toggle checkbox
    }

    // If clicking on a product card area (but not on buttons or tier badges), toggle the checkbox
    const productCard = e.target.closest(".product-card");
    if (
      productCard &&
      !e.target.classList.contains("product-checkbox") &&
      !e.target.classList.contains("checkbox-custom") &&
      !e.target.classList.contains("product-tier-badge") &&
      !e.target.classList.contains("product-free-ship-badge") &&
      !e.target.classList.contains("product-tier-badges") &&
      !e.target.classList.contains("product-tier-badges-track")
    ) {
      const checkbox = productCard.querySelector(".product-checkbox");
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  });

  // Desktop Search
  desktopSearchInput.addEventListener("input", (e) => {
    searchQuery = e.target.value.toLowerCase();
    mobileSearchInput.value = searchQuery;
    filterAndSortProducts();
  });

  // Mobile Search
  mobileSearchInput.addEventListener("input", (e) => {
    searchQuery = e.target.value.toLowerCase();
    desktopSearchInput.value = searchQuery;
    filterAndSortProducts();
  });

  // Mobile Search Button
  mobileSearchBtn.addEventListener("click", () => {
    mobileSearchBar.style.display = "block";
    mobileSearchInput.focus();
  });

  // Mobile Search Close
  mobileSearchClose.addEventListener("click", () => {
    mobileSearchBar.style.display = "none";
    searchQuery = "";
    mobileSearchInput.value = "";
    desktopSearchInput.value = "";
    filterAndSortProducts();
  });

  // Desktop Sort
  sortSelect.addEventListener("change", (e) => {
    currentSort = e.target.value;
    filterAndSortProducts();
  });

  // Mobile Sort Button
  mobileSortBtn.addEventListener("click", () => {
    sortModal.classList.add("active");
    updateSortModalSelection();
  });

  // Close Sort Modal
  closeSortModal.addEventListener("click", () => {
    sortModal.classList.remove("active");
  });

  sortModal.addEventListener("click", (e) => {
    if (e.target === sortModal) {
      sortModal.classList.remove("active");
    }
  });

  // Sort Options
  document.querySelectorAll(".sort-option").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      currentSort = e.target.dataset.sort;
      sortSelect.value = currentSort;
      sortModal.classList.remove("active");
      filterAndSortProducts();
    });
  });

  // Filter checkboxes
  document.querySelectorAll("input[data-filter]").forEach((checkbox) => {
    checkbox.addEventListener("change", (e) => {
      const filterType = e.target.dataset.filter;
      const filterValue = e.target.value;

      if (e.target.checked) {
        activeFilters[filterType].push(filterValue);
      } else {
        activeFilters[filterType] = activeFilters[filterType].filter(
          (v) => v !== filterValue,
        );
      }

      filterAndSortProducts();
    });
  });

  // Clear filters
  clearFiltersBtn.addEventListener("click", clearAllFilters);

  // Mobile filter toggle
  mobileFilterBtn.addEventListener("click", () => {
    filterSidebar.classList.add("active");
    filterOverlay.classList.add("active");
  });

  closeFiltersBtn.addEventListener("click", closeFilters);
  filterOverlay.addEventListener("click", closeFilters);

  // Apply filters button (closes drawer)
  applyFiltersBtn.addEventListener("click", closeFilters);

  // Checkout button
  checkoutBtn.addEventListener("click", () => {
    const count = getTotalItemCount();
    if (count > 0) {
      // Check if user should be prompted to add more for better discount
      if (shouldShowTierModal(count)) {
        showTierModal();
      } else {
        proceedToCheckout();
      }
    }
  });

  // Drawer handle toggle
  drawerHandle.addEventListener("click", toggleDrawer);

  // Drawer close button
  drawerClose.addEventListener("click", closeDrawer);

  // Close drawer when clicking outside
  document.addEventListener("click", (e) => {
    if (
      bundleDrawer.classList.contains("expanded") &&
      !bundleDrawer.contains(e.target) &&
      !e.target.closest(".product-card")
    ) {
      closeDrawer();
    }
  });

  // Independent scroll for filters sidebar
  filterSidebar.addEventListener(
    "wheel",
    (e) => {
      const isScrollingDown = e.deltaY > 0;
      const isScrollingUp = e.deltaY < 0;
      const isAtTop = filterSidebar.scrollTop === 0;
      const isAtBottom =
        filterSidebar.scrollTop + filterSidebar.clientHeight >=
        filterSidebar.scrollHeight - 1;

      // Prevent document scroll if:
      // - Scrolling down and not at bottom
      // - Scrolling up and not at top
      if ((isScrollingDown && !isAtBottom) || (isScrollingUp && !isAtTop)) {
        e.stopPropagation();
      }
    },
    { passive: true },
  );

  // Tier modal close
  tierModalClose.addEventListener("click", closeTierModal);

  // Tier modal - Continue to checkout
  tierContinueBtn.addEventListener("click", proceedToCheckout);

  // Tier modal - Add more items
  tierAddMoreBtn.addEventListener("click", () => {
    closeTierModal();
    closeDrawer();
    // Scroll to top to show products
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  // Close tier modal when clicking outside
  tierModal.addEventListener("click", (e) => {
    if (e.target === tierModal) {
      closeTierModal();
    }
  });
}

// Close mobile filters
function closeFilters() {
  filterSidebar.classList.remove("active");
  filterOverlay.classList.remove("active");
}

// Clear all filters
function clearAllFilters() {
  activeFilters = { type: [], profile: [], meal: [], diet: [] };
  searchQuery = "";
  desktopSearchInput.value = "";
  mobileSearchInput.value = "";

  document.querySelectorAll("input[data-filter]").forEach((checkbox) => {
    checkbox.checked = false;
  });

  filterAndSortProducts();
}

// Get total count of all items (sum of quantities)
function getTotalItemCount() {
  let total = 0;
  selectedProducts.forEach((quantity) => {
    total += quantity;
  });
  return total;
}

// Calculate the price of the next bottle based on current cart count
// Progressive discount: 1st=$10, 2nd=10% off, 3rd=20% off, 4th=30% off, 5th+=40% off
function getNextBottlePrice() {
  const currentCount = getTotalItemCount();
  const nextBottleIndex = currentCount; // 0-indexed: 0=first bottle, 1=second, etc.
  return getPriceForPosition(nextBottleIndex);
}

// Get current tier price for all items in cart
function getCurrentTierPrice() {
  const currentCount = getTotalItemCount();
  if (currentCount === 0) {
    return BUNDLE_CONFIG.pricing.basePrice;
  }
  // Get price for the last bottle in the cart (highest discount applied)
  return getPriceForPosition(currentCount - 1);
}

// Shake the drawer handle when product is added
function shakeDrawerHandle() {
  const drawerHandle = document.getElementById("drawerHandle");

  // Add shake class
  drawerHandle.classList.add("shake");

  // Remove shake class after animation completes
  setTimeout(() => {
    drawerHandle.classList.remove("shake");
  }, 600); // Match animation duration (0.6s)
}

// Add product to bundle (first time)
function addProduct(productId) {
  selectedProducts.set(productId, 1);

  // Sync with Shopify cart
  addToShopifyCart(productId, 1);

  updateBundleBar();
  updateDrawer();
  filterAndSortProducts();

  // Shake the drawer handle to indicate item was added
  shakeDrawerHandle();

  // Trigger product card animation
  setTimeout(() => {
    const productCard = document.querySelector(
      `.product-card[data-product-id="${productId}"]`,
    );
    if (productCard) {
      productCard.classList.add("just-added");
      setTimeout(() => {
        productCard.classList.remove("just-added");
      }, 500); // Match animation duration
    }
  }, 10);

  // Show toast after re-render
  setTimeout(() => {
    const newButton = document.querySelector(
      `button[data-product-id="${productId}"]`,
    );
    if (newButton) {
      showToast(newButton);
    }
  }, 10);
}

// Increment product quantity
function incrementProduct(productId) {
  const currentQty = selectedProducts.get(productId) || 0;
  const newQty = currentQty + 1;
  selectedProducts.set(productId, newQty);

  // Sync with Shopify cart -> newQty
  updateShopifyCart(productId, newQty);

  updateBundleBar();
  updateDrawer();
  filterAndSortProducts();

  // Shake the drawer handle
  shakeDrawerHandle();

  // Trigger product card animation
  setTimeout(() => {
    const productCard = document.querySelector(
      `.product-card[data-product-id="${productId}"]`,
    );
    if (productCard) {
      productCard.classList.add("just-added");
      setTimeout(() => {
        productCard.classList.remove("just-added");
      }, 500); // Match animation duration
    }
  }, 10);

  // Show toast after re-render
  setTimeout(() => {
    const newButton = document.querySelector(
      `button[data-product-id="${productId}"]`,
    );
    if (newButton) {
      showToast(newButton);
    }
  }, 10);
}

// Decrement product quantity (remove if quantity becomes 0)
function decrementProduct(productId) {
  const currentQty = selectedProducts.get(productId) || 0;
  if (currentQty <= 1) {
    selectedProducts.delete(productId);
    // Sync with Shopify cart -> 0
    updateShopifyCart(productId, 0);
  } else {
    const newQty = currentQty - 1;
    selectedProducts.set(productId, newQty);
    // Sync with Shopify cart -> newQty
    updateShopifyCart(productId, newQty);
  }

  updateBundleBar();
  updateDrawer();
  filterAndSortProducts();
}

// Remove product completely from bundle
function removeProduct(productId) {
  if (selectedProducts.has(productId)) {
    selectedProducts.delete(productId);
    // Sync with Shopify cart -> 0
    updateShopifyCart(productId, 0);
  }

  updateBundleBar();
  updateDrawer();
  filterAndSortProducts();
}

// Show toast notification near the button
function showToast(buttonElement) {
  const count = getTotalItemCount();
  const productId = Number(buttonElement.dataset.productId);
  const isSpecial = productId === SPECIAL_PRODUCT_ID;

  // Get random positive word
  const randomPositive =
    positiveWords[Math.floor(Math.random() * positiveWords.length)];

  // Get action message dynamically from config
  const actionMessage = isSpecial 
    ? `Added to bundle!` 
    : getToastMessage(count);

  // Combine for toast display
  const message = `${randomPositive} ${actionMessage}`;

  // Save only the action message for drawer rotation (no random positive word)
  lastToastMessage = actionMessage;
  startDrawerTextRotation();

  // Create toast element
  const toast = document.createElement("div");
  toast.className = "toast-notification";
  toast.textContent = message;

  // Get the product card
  const productCard = buttonElement.closest(".product-card");

  if (!productCard) {
    return;
  }

  // Ensure product card has relative positioning
  const cardPosition = getComputedStyle(productCard).position;
  if (cardPosition === "static") {
    productCard.style.position = "relative";
  }

  // Add to product card
  productCard.appendChild(toast);

  // Remove toast after animation completes (4 seconds)
  setTimeout(() => {
    if (toast.parentNode) {
      toast.remove();
    }
  }, 4000);
}

// Update bundle bar
function updateBundleBar() {
  const count = getTotalItemCount();
  const bundleInfo = document.querySelector(".bundle-info");

  // Bundle bar and drawer are always visible, just update content
  const pricing = calculatePricing();
  const freeShipText = pricing.hasFreeShipping
    ? '<span class="free-ship-text">+ FREE Ship</span>'
    : "";

  bundleInfo.innerHTML = `
        <span class="bundle-count">${count} Item${count !== 1 ? "s" : ""}</span>
        <span class="bundle-pricing">
            ${pricing.discountPercent > 0 || pricing.discountAmount > 0 ? `<span class="original-price">${formatPrice(pricing.subtotal)}</span>` : ""}
            <span class="current-price">${formatPrice(pricing.total)}</span>
            ${freeShipText}
        </span>
    `;

  // Update checkout button state
  if (count === 0) {
    checkoutBtn.disabled = true;
    checkoutBtn.removeAttribute("data-item-count");
  } else {
    checkoutBtn.disabled = false;
    checkoutBtn.setAttribute("data-item-count", count);
  }

  // Update tier progress indicators
  updateTierProgress(count, pricing.discountPercent);
}

// Update tier progress badges in bundle bar
function updateTierProgress(itemCount, currentDiscountPercent) {
  const tierBadges = document.querySelectorAll(
    ".bundle-tier-progress .tier-badge-step",
  );
  const freeShipBadge = document.getElementById("bundleFreeShip");

  // Tier thresholds from config (skip first tier which is 0% discount)
  const tiers = BUNDLE_CONFIG.tiers.slice(1).map((tier) => ({
    count: tier.itemCount,
    discount: tier.discount * 100, // Convert 0.10 to 10
  }));

  tierBadges.forEach((badge, index) => {
    const tierDiscount = tiers[index].discount;
    const tierCount = tiers[index].count;

    // Remove all state classes
    badge.classList.remove("locked", "active", "reached");

    if (itemCount >= tierCount) {
      // Tier is reached
      badge.classList.add("reached");
    } else if (itemCount === tierCount - 1) {
      // Next item will unlock this tier
      badge.classList.add("active");
    } else {
      // Tier is locked
      badge.classList.add("locked");
    }
  });

  // Update FREE SHIP badge state
  freeShipBadge.classList.remove("locked", "active", "reached");

  if (itemCount >= FREE_SHIPPING_THRESHOLD) {
    // FREE SHIP is unlocked (filled red)
    freeShipBadge.classList.add("reached");
  } else {
    // FREE SHIP is locked (inactive border)
    freeShipBadge.classList.add("locked");
  }
}

// Filter and Sort products
function filterAndSortProducts() {
  let filtered = [...products];

  // Apply search filter
  if (searchQuery) {
    filtered = filtered.filter((product) =>
      product.name.toLowerCase().includes(searchQuery),
    );
  }

  // Apply profile filters
  if (activeFilters.profile.length > 0) {
    filtered = filtered.filter((product) =>
      activeFilters.profile.some((filter) => product.profiles.includes(filter)),
    );
  }

  // Apply meal filters
  if (activeFilters.meal.length > 0) {
    filtered = filtered.filter((product) =>
      activeFilters.meal.some((filter) => product.meals.includes(filter)),
    );
  }

  // Apply diet filters
  if (activeFilters.diet.length > 0) {
    filtered = filtered.filter((product) =>
      activeFilters.diet.every((filter) => product.diets.includes(filter)),
    );
  }

  // Apply type filters
  if (activeFilters.type.length > 0) {
    filtered = filtered.filter((product) =>
      activeFilters.type.every((filter) => product.type.includes(filter)),
    );
  }

  // Apply sorting
  if (currentSort === "alphabetical") {
    filtered.sort((a, b) => a.name.localeCompare(b.name));
  } else if (currentSort === "alphabetical-desc") {
    filtered.sort((a, b) => b.name.localeCompare(a.name));
  } else if (currentSort === "best-selling") {
    // Sort best-selling items first
    filtered.sort((a, b) => {
      if (a.tag === "best-selling" && b.tag !== "best-selling") return -1;
      if (a.tag !== "best-selling" && b.tag === "best-selling") return 1;
      return 0;
    });
  }
  // 'featured' keeps original order

  renderProducts(filtered);
  renderFilterBadges();
  return filtered;
}

// Update sort modal selection
function updateSortModalSelection() {
  document.querySelectorAll(".sort-option").forEach((btn) => {
    if (btn.dataset.sort === currentSort) {
      btn.classList.add("active");
    } else {
      btn.classList.remove("active");
    }
  });
}

// Update drawer with selected products
function updateDrawer() {
  const count = getTotalItemCount();

  if (count === 0) {
    drawerProducts.innerHTML =
      '<p style="text-align: center; color: #999; padding: 20px;">No items in your bundle yet</p>';
    drawerSubtotal.textContent = "$0.00";
    drawerDiscountRow.style.display = "none";
    drawerGiftCardRow.style.display = "none";
    drawerTotal.textContent = "$0.00";
    drawerFreeShippingRow.style.display = "none";
    return;
  }

  // Render selected products
  drawerProducts.innerHTML = "";

  let itemIndex = 0;
  selectedProducts.forEach((quantity, productId) => {
    const product = products.find((p) => p.first_variant_id === productId);
    if (!product) return;

    const isSpecialItem = Number(productId) === SPECIAL_PRODUCT_ID;

    // Render each quantity as a separate item for progressive discounts
    for (let q = 0; q < quantity; q++) {
      const productItem = document.createElement("div");
      productItem.className = "drawer-product-item";

      // Progressive discount: 0%, 10%, 20%, 30%, 40%...
      const itemDiscountPercent = isSpecialItem ? 0 : getDiscountForPosition(itemIndex);
      const itemDiscountedPrice = isSpecialItem ? SPECIAL_PRODUCT_PRICE : getPriceForPosition(itemIndex);
      const itemOriginalPrice = isSpecialItem ? SPECIAL_PRODUCT_ORIGINAL_PRICE : BUNDLE_CONFIG.pricing.basePrice;

      let priceHTML = "";
      if (isSpecialItem) {
        priceHTML = `<p class="drawer-product-price">${formatPrice(itemDiscountedPrice)}</p>`;
      } else if (itemIndex === 0) {
        // First item - no discount
        priceHTML = `<p class="drawer-product-price">${formatPrice(itemDiscountedPrice)}</p>`;
      } else {
        // Progressive discount: 2nd item = 10%, 3rd = 20%, 4th = 30%, 5th+ = 40%
        priceHTML = `
                    <p class="drawer-product-price">
                        <span class="item-original-price">${formatPrice(itemOriginalPrice)}</span>
                        <span class="item-discount-badge">${(itemDiscountPercent * 100).toFixed(0)}% Off</span>
                        <span class="item-discounted-price">${formatPrice(itemDiscountedPrice)}</span>
                    </p>
                `;
      }

      productItem.innerHTML = `
                <img src="${product.image}" alt="${product.name}" class="drawer-product-image">
                <div class="drawer-product-info">
                    <p class="drawer-product-name">${product.name}</p>
                    ${priceHTML}
                </div>
                <button class="drawer-product-remove" data-product-id="${product.first_variant_id}" title="Remove from bundle">&times;</button>
            `;
      drawerProducts.appendChild(productItem);
      itemIndex++;
    }
  });

  // Add free gifts (rewards with images) that have been unlocked
  const activeRewards = getActiveRewards(count);
  activeRewards.forEach((reward) => {
    // Only show rewards that have images (physical items)
    if (reward.image) {
      const rewardItem = document.createElement("div");
      rewardItem.className = "drawer-product-item gift-card-item";

      // If reward has a value, show it as 100% off
      let priceHTML = "";
      if (reward.value) {
        priceHTML = `
                    <p class="drawer-product-price">
                        <span class="item-original-price">${formatPrice(reward.value)}</span>
                        <span class="item-discount-badge">100% Off</span>
                        <span class="item-discounted-price">$0.00</span>
                    </p>
                `;
      } else {
        // No value, just show FREE
        priceHTML = `<p class="drawer-product-price" style="color: #2db546; font-weight: 700;">FREE</p>`;
      }

      rewardItem.innerHTML = `
                <img src="${reward.image}" alt="${reward.name}" class="drawer-product-image">
                <div class="drawer-product-info">
                    <p class="drawer-product-name">${reward.name} 🎉</p>
                    ${priceHTML}
                </div>
            `;
      drawerProducts.appendChild(rewardItem);
    }
  });

  // Add event listeners for remove buttons
  drawerProducts.querySelectorAll(".drawer-product-remove").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const productId = parseInt(e.target.dataset.productId);
      decrementProduct(productId);
    });
  });

  // Update pricing breakdown
  const pricing = calculatePricing();
  drawerSubtotal.textContent = formatPrice(pricing.subtotal);

  // Show discount
  if (pricing.discountPercent > 0) {
    drawerDiscountRow.style.display = "flex";
    drawerDiscountLabel.textContent = `Total Saved (${(pricing.discountPercent * 100).toFixed(0)}%):`;
    drawerDiscount.textContent = `-${formatPrice(pricing.discountAmount)}`;
  } else {
    drawerDiscountRow.style.display = "none";
  }

  // Show gift card
  if (pricing.hasGiftCard) {
    drawerGiftCardRow.style.display = "flex";
  } else {
    drawerGiftCardRow.style.display = "none";
  }

  drawerTotal.textContent = formatPrice(pricing.total);

  // Show free shipping (only when free shipping is unlocked)
  if (pricing.hasFreeShipping) {
    drawerFreeShippingRow.style.display = "flex";
  } else {
    drawerFreeShippingRow.style.display = "none";
  }
}

// Toggle drawer open/close
function toggleDrawer() {
  const isExpanding = !bundleDrawer.classList.contains("expanded");
  bundleDrawer.classList.toggle("expanded");

  if (isExpanding) {
    stopDrawerTextRotation();
  } else {
    // Restart rotation when closing if there's a message
    if (lastToastMessage) {
      startDrawerTextRotation();
    }
  }
}

// Close drawer
function closeDrawer() {
  bundleDrawer.classList.remove("expanded");
  // Restart rotation when closing if there's a message
  if (lastToastMessage) {
    startDrawerTextRotation();
  }
}

// Rotate drawer handle text between default and last toast message
function startDrawerTextRotation() {
  // Clear any existing interval
  if (drawerTextInterval) {
    clearInterval(drawerTextInterval);
  }

  // Only rotate if we have a toast message and drawer is not expanded
  if (!lastToastMessage) return;

  let showingToast = false;
  const defaultText = "View Your Bundle Details";
  const drawerHandleTextElement = document.querySelector(".drawer-handle-text");

  // Update the drawer text with fade effect
  function updateDrawerText() {
    if (bundleDrawer.classList.contains("expanded")) {
      // Stop rotation when drawer is expanded
      clearInterval(drawerTextInterval);
      drawerTextInterval = null;
      return;
    }

    showingToast = !showingToast;
    const iconSVG = drawerHandleTextElement.querySelector("svg");

    // Fade out
    drawerHandleTextElement.style.opacity = "0";

    setTimeout(() => {
      // Change text while invisible
      if (showingToast) {
        drawerHandleTextElement.innerHTML = `${iconSVG.outerHTML}${lastToastMessage}`;
      } else {
        drawerHandleTextElement.innerHTML = `${iconSVG.outerHTML}${defaultText}`;
      }

      // Fade in
      drawerHandleTextElement.style.opacity = "1";
    }, 300);
  }

  // Start rotating every 3 seconds
  drawerTextInterval = setInterval(updateDrawerText, 3000);
}

// Stop drawer text rotation when drawer is opened
function stopDrawerTextRotation() {
  if (drawerTextInterval) {
    clearInterval(drawerTextInterval);
    drawerTextInterval = null;
  }

  // Reset to default text
  const drawerHandleTextElement = document.querySelector(".drawer-handle-text");
  const iconSVG = drawerHandleTextElement.querySelector("svg");
  drawerHandleTextElement.innerHTML = `${iconSVG.outerHTML}View Your Bundle Details`;
  drawerHandleTextElement.style.opacity = "1";
}

// Check if user should be prompted to add more items for better discount
function shouldShowTierModal(itemCount) {
  // Check if user is exactly 1 item away from the next tier
  const nextTierThresholds = [2, 3, 4, 5];
  return nextTierThresholds.includes(itemCount + 1);
}

// Get information about the next tier
function getNextTierInfo(currentCount) {
  // Build tiers from config (skip first tier which is 0% discount)
  const tiers = BUNDLE_CONFIG.tiers.slice(1).map((tier) => ({
    threshold: tier.itemCount,
    discount: tier.discount * 100, // Convert 0.10 to 10
    hasFreeShip: tier.itemCount >= FREE_SHIPPING_THRESHOLD,
  }));

  // Find the next tier the user hasn't reached yet
  for (let tier of tiers) {
    if (currentCount < tier.threshold) {
      return {
        itemsNeeded: tier.threshold - currentCount,
        itemsForNextTier: tier.threshold,
        discount: tier.discount,
        hasFreeShip: tier.hasFreeShip,
      };
    }
  }

  // User has reached max tier
  return null;
}

// Populate tier modal product recommendations
function populateTierRecommendations() {
  // Get products not yet in bundle
  const availableProducts = products.filter((p) => !selectedProducts.has(p.id));

  // Pick 2 random products to recommend
  const recommendations = [];
  const shuffled = [...availableProducts].sort(() => 0.5 - Math.random());
  recommendations.push(...shuffled.slice(0, 2));

  // Clear existing recommendations
  tierRecommendations.innerHTML = "";

  if (recommendations.length === 0) {
    tierRecommendations.style.display = "none";
    return;
  }

  tierRecommendations.style.display = "flex";

  recommendations.forEach((product) => {
    const isAdded = selectedProducts.has(product.first_variant_id);

    const item = document.createElement("div");
    item.className = `tier-recommendation-item product-card ${isAdded ? "added" : ""}`;
    item.setAttribute("data-product-id", product.first_variant_id);

    // Show tag if product has one
    let tagHTML = "";
    if (product.tag) {
      const tagLabel =
        product.tag === "best-selling"
          ? "BEST SELLING"
          : product.tag === "limited-edition"
            ? "LIMITED"
            : "NEW";
      tagHTML = `<div class="product-tag ${product.tag}">${tagLabel}</div>`;
    }

    const quantity = selectedProducts.get(product.first_variant_id) || 0;

    const checkboxHTML = `
            <label class="product-checkbox-wrapper">
                <input type="checkbox" class="product-checkbox modal-product-checkbox" data-product-id="${product.first_variant_id}" ${isAdded ? "checked" : ""}>
                <span class="checkbox-custom"></span>
            </label>
        `;

    // Calculate next bottle price for pricing display (same as main grid)
    const currentCount = getTotalItemCount();
    const nextBottlePrice = getNextBottlePrice();
    const hasDiscount = nextBottlePrice < PRICE_PER_BOTTLE;
    const discountPercent = hasDiscount
      ? Math.round(
        ((PRICE_PER_BOTTLE - nextBottlePrice) / PRICE_PER_BOTTLE) * 100,
      )
      : 0;

    // Get all discount tiers from config
    const allTiers = getAllTierDiscounts();

    // Only show pricing for UNCHECKED items when there are items in cart
    const pricingHTML =
      !isAdded && currentCount > 0
        ? `
            <div class="product-pricing">
                <div class="product-tier-badges">
                    <div class="product-tier-badges-track">
                        ${allTiers
          .map((tier) => {
            const isActive = tier === discountPercent;
            const isInactive = tier > discountPercent;
            return `<span class="product-tier-badge ${isActive ? "active" : ""} ${isInactive ? "inactive" : ""}">${tier}% Off</span>`;
          })
          .join("")}
                    </div>
                </div>
                <div class="product-pricing-row">
                    <span class="product-price-original">${formatPrice(PRICE_PER_BOTTLE)}</span>
                    <span class="product-price-current">${formatPrice(nextBottlePrice)}</span>
                </div>
            </div>
        `
        : "";

    // Show "Add more" pricing only (drawer shows full breakdown)
    const addedPriceHTML = isAdded
      ? (() => {
        const nextPrice = getNextBottlePrice();
        const currentTotalCount = getTotalItemCount();
        // Get discount for the NEXT bottle from config
        const nextBottleDiscount = getDiscountForPosition(currentTotalCount);
        const discountPercent = Math.round(nextBottleDiscount * 100);

        return discountPercent > 0
          ? `
                <div class="product-added-pricing">
                    <div class="add-more-row">
                        <span>Add more at ${formatPrice(nextPrice)}</span>
                        <span class="discount-badge">${discountPercent}% off</span>
                    </div>
                </div>
            `
          : "";
      })()
      : "";

    const controlsHTML = isAdded
      ? `
            <div class="product-quantity-controls">
                <button class="btn-quantity-minus modal-btn-quantity" data-product-id="${product.first_variant_id}">−</button>
                <span class="product-quantity">${quantity}</span>
                <button class="btn-quantity-plus modal-btn-quantity" data-product-id="${product.first_variant_id}">+</button>
            </div>
        `
      : "";

    item.innerHTML = `
            ${tagHTML}
            ${checkboxHTML}
            <img src="${product.image}" alt="${product.name}" class="product-image">
            <h3 class="product-name">${product.name}</h3>
            ${pricingHTML}
            ${addedPriceHTML}
            ${controlsHTML}
        `;

    tierRecommendations.appendChild(item);
  });

  // Attach event listeners to checkboxes
  const modalCheckboxes = tierRecommendations.querySelectorAll(
    ".modal-product-checkbox",
  );
  modalCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", (e) => {
      const productId = parseInt(e.target.getAttribute("data-product-id"));
      if (e.target.checked) {
        addProduct(productId);
        // Show toast notification
        const productCard = e.target.closest(".tier-recommendation-item");
        if (productCard) {
          showModalToast(productCard, "Added! ✓");
        }
        // Delay the modal update to let user see the "Added" state
        setTimeout(() => {
          updateTierModalAfterAdd();
        }, 1500);
      } else {
        removeProduct(productId);
        updateTierModalAfterAdd();
      }
    });
  });

  // Attach event listeners to quantity buttons
  const modalPlusButtons = tierRecommendations.querySelectorAll(
    ".btn-quantity-plus.modal-btn-quantity",
  );
  const modalMinusButtons = tierRecommendations.querySelectorAll(
    ".btn-quantity-minus.modal-btn-quantity",
  );

  modalPlusButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      const productId = parseInt(button.getAttribute("data-product-id"));
      incrementProduct(productId);
      // Show toast notification
      const productCard = button.closest(".tier-recommendation-item");
      if (productCard) {
        showModalToast(productCard, "Added! ✓");
      }
      // Update modal immediately for quantity changes
      setTimeout(() => {
        updateTierModalAfterAdd();
      }, 1000);
    });
  });

  modalMinusButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      const productId = parseInt(button.getAttribute("data-product-id"));
      decrementProduct(productId);
      updateTierModalAfterAdd();
    });
  });
}

// Show toast in modal
function showModalToast(productCard, message) {
  // Create toast element
  const toast = document.createElement("div");
  toast.className = "toast-notification";
  toast.textContent = message;

  // Ensure product card has relative positioning
  const cardPosition = getComputedStyle(productCard).position;
  if (cardPosition === "static") {
    productCard.style.position = "relative";
  }

  // Add to product card
  productCard.appendChild(toast);

  // Remove toast after animation completes
  setTimeout(() => {
    if (toast.parentNode) {
      toast.remove();
    }
  }, 2000);
}

// Update modal after adding a product
function updateTierModalAfterAdd() {
  const currentCount = getTotalItemCount();
  const nextTierInfo = getNextTierInfo(currentCount);

  // Hide "Add More Items" button and make "Continue to Checkout" red with bounce
  tierAddMoreBtn.style.display = "none";
  tierContinueBtn.style.backgroundColor = "#e63946";
  tierContinueBtn.style.color = "white";
  tierContinueBtn.style.borderColor = "#e63946";
  tierContinueBtn.classList.add("bounce");

  // Calculate current pricing
  const currentPricing = calculatePricing(currentCount);

  // Update current total
  if (tierCurrentTotal) {
    tierCurrentTotal.textContent = formatPrice(currentPricing.total);
  }

  if (!nextTierInfo) {
    // At max tier
    tierModalMessage.innerHTML = `<strong>🎉 You've unlocked maximum savings!</strong>`;
    // Still show badges to show achievement
    populateModalBadges(currentCount);
    populateTierRecommendations();
    return;
  }

  // Get active rewards for messaging
  const activeRewards = getActiveRewards(nextTierInfo.itemsForNextTier);
  const hasShipping = activeRewards.some((r) => r.type === "free-shipping");

  // Update modal message with new tier info
  const itemsNeeded = nextTierInfo.itemsNeeded;
  const discountText = hasShipping
    ? `<strong>${nextTierInfo.discount}%</strong> off + <strong>FREE Shipping*</strong>`
    : `<strong>${nextTierInfo.discount}%</strong> off`;

  tierModalMessage.innerHTML = `
        Add just <strong>${itemsNeeded} more bottle${itemsNeeded > 1 ? "s" : ""}</strong> to unlock ${discountText}!
    `;

  // Update progress badges with new count
  populateModalBadges(currentCount);

  // Update product recommendations (show new products, replacing added ones)
  populateTierRecommendations();
}

// Populate modal progress badges (combined discounts and gifts)
function populateModalBadges(currentCount) {
  const modalAllBadges = document.getElementById("modalAllBadges");

  if (!modalAllBadges) return;

  // Clear existing badges
  modalAllBadges.innerHTML = "";

  let activeBadgeIndex = -1;
  let badgeIndex = 0;

  // Populate discount badges (skip first tier which is 0%)
  BUNDLE_CONFIG.tiers.slice(1).forEach((tier) => {
    const badge = document.createElement("div");
    const itemsNeeded = tier.itemCount - currentCount;

    let badgeClass = "modal-badge-item";
    let progressHTML = "";
    let checkmarkHTML = "";

    if (currentCount >= tier.itemCount) {
      badgeClass += " reached";
      activeBadgeIndex = badgeIndex; // Track last reached tier
      // Add checkmark for reached tiers
      checkmarkHTML = `
                <svg class="modal-badge-checkmark" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            `;
    } else if (itemsNeeded === 1) {
      badgeClass += " next";
      if (activeBadgeIndex === -1) activeBadgeIndex = badgeIndex; // Track next tier if none reached
      progressHTML = `<div class="modal-badge-progress">+${itemsNeeded}</div>`;
    } else if (itemsNeeded > 0) {
      badgeClass += " locked";
      progressHTML = `<div class="modal-badge-progress">+${itemsNeeded}</div>`;
    }

    badge.className = badgeClass;
    badge.innerHTML = `
            ${progressHTML}
            <div class="modal-badge-number">
                ${checkmarkHTML || tier.itemCount}
            </div>
            <div class="modal-badge-text">${tier.label} off</div>
        `;
    modalAllBadges.appendChild(badge);
    badgeIndex++;
  });

  // Populate gift/reward badges
  BUNDLE_CONFIG.rewards.forEach((reward) => {
    const badge = document.createElement("div");
    const itemsNeeded = reward.threshold - currentCount;

    let badgeClass = "modal-badge-item gift";
    let progressHTML = "";
    let checkmarkHTML = "";

    if (currentCount >= reward.threshold) {
      badgeClass += " reached";
      if (activeBadgeIndex < badgeIndex) activeBadgeIndex = badgeIndex; // Track last reached gift
      // Add checkmark for reached gift tiers
      checkmarkHTML = `
                <svg class="modal-badge-checkmark" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            `;
    } else if (itemsNeeded === 1) {
      badgeClass += " next";
      if (activeBadgeIndex === -1) activeBadgeIndex = badgeIndex; // Track next gift if none reached
      progressHTML = `<div class="modal-badge-progress">+${itemsNeeded}</div>`;
    } else if (itemsNeeded > 0) {
      badgeClass += " locked";
      progressHTML = `<div class="modal-badge-progress">+${itemsNeeded}</div>`;
    }

    badge.className = badgeClass;
    badge.innerHTML = `
            ${progressHTML}
            <div class="modal-badge-number">
                ${checkmarkHTML || `${reward.threshold}+`}
            </div>
            <div class="modal-badge-text">${reward.label}</div>
        `;
    modalAllBadges.appendChild(badge);
    badgeIndex++;
  });

  // Auto-scroll to center the active badge
  setTimeout(() => {
    if (activeBadgeIndex >= 0) {
      const activeBadge = modalAllBadges.children[activeBadgeIndex];
      if (activeBadge) {
        const containerCenter = modalAllBadges.offsetWidth / 2;
        const badgeCenter =
          activeBadge.offsetLeft + activeBadge.offsetWidth / 2;
        const scrollPosition = badgeCenter - containerCenter;
        modalAllBadges.scrollLeft = scrollPosition;
      }
    }
  }, 50);
}

// Show tier optimization modal
function showTierModal() {
  // Reset button states when opening modal
  tierAddMoreBtn.style.display = "inline-block";
  tierContinueBtn.style.backgroundColor = "";
  tierContinueBtn.style.color = "";
  tierContinueBtn.style.borderColor = "";
  tierContinueBtn.classList.remove("bounce");

  const currentCount = getTotalItemCount();
  const nextTierInfo = getNextTierInfo(currentCount);

  if (!nextTierInfo) {
    return; // Already at max tier
  }

  // Get active rewards for messaging
  const activeRewards = getActiveRewards(nextTierInfo.itemsForNextTier);
  const hasShipping = activeRewards.some((r) => r.type === "free-shipping");

  // Update modal message
  const itemsNeeded = nextTierInfo.itemsNeeded;
  const discountText = hasShipping
    ? `<strong>${nextTierInfo.discount}%</strong> off + <strong>FREE Shipping*</strong>`
    : `<strong>${nextTierInfo.discount}%</strong> off`;

  tierModalMessage.innerHTML = `
        Add just <strong>${itemsNeeded} more bottle${itemsNeeded > 1 ? "s" : ""}</strong> to unlock ${discountText}!
    `;

  // Calculate current pricing
  const currentPricing = calculatePricing(currentCount);

  // Update current total
  if (tierCurrentTotal) {
    tierCurrentTotal.textContent = formatPrice(currentPricing.total);
  }

  // Populate progress badges
  populateModalBadges(currentCount);

  // Populate product recommendations
  populateTierRecommendations();

  tierModal.classList.add("active");
}

// Close tier modal
function closeTierModal() {
  tierModal.classList.remove("active");
}

// Proceed to actual checkout (placeholder)
// Proceed to checkout (now just redirects)
function proceedToCheckout() {
  window.location.href = "/checkout";
}

/**
 * Adds an item to the Shopify cart
 * @param {number} variantId - The variant ID to add
 * @param {number} quantity - The quantity to add
 */
function addToShopifyCart(variantId, quantity) {
  const formData = {
    items: [
      {
        id: variantId,
        quantity: quantity,
      },
    ],
    sections: "cart-icon-bubble",
    sections_url: window.location.pathname,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((json) => {
          throw new Error(json.description || "API Error");
        });
      }
      return response.json();
    })
    .then((cart) => {
      console.log("Item added to cart:", cart);

      // Update Cart Icon Bubble (Header Count)
      if (cart.sections && cart.sections["cart-icon-bubble"]) {
        const cartIconBubble = document.getElementById("cart-icon-bubble");
        if (cartIconBubble) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(
            cart.sections["cart-icon-bubble"],
            "text/html",
          );

          // Try to find the section content consistent with cart.js patterns
          const sectionContent = doc.querySelector(".shopify-section");
          if (sectionContent) {
            cartIconBubble.innerHTML = sectionContent.innerHTML;
          } else {
            // Fallback: use the whole returned string
            cartIconBubble.innerHTML = cart.sections["cart-icon-bubble"];
          }
        }
      }
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
      // alert("Failed to update cart. Please try again.");
    });
}

/**
 * Updates the Shopify cart immediately using /cart/update.js
 * This is more robust for variant IDs than /cart/change.js
 * @param {number} variantId - The variant ID to update
 * @param {number} quantity - The new quantity
 */
function updateShopifyCart(variantId, quantity) {
  const formData = {
    updates: {
      [variantId]: quantity
    },
    sections: 'cart-icon-bubble',
    sections_url: window.location.pathname
  };

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(json => { throw new Error(json.description || 'API Error') });
      }
      return response.json();
    })
    .then(cart => {
      console.log('Cart updated:', cart);

      // Update Cart Icon Bubble (Header Count)
      if (cart.sections && cart.sections['cart-icon-bubble']) {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(cart.sections['cart-icon-bubble'], 'text/html');

          // Try to find the section content consistent with cart.js patterns
          const sectionContent = doc.querySelector('.shopify-section');
          if (sectionContent) {
            cartIconBubble.innerHTML = sectionContent.innerHTML;
          } else {
            // Fallback: use the whole returned string
            cartIconBubble.innerHTML = cart.sections['cart-icon-bubble'];
          }
        }
      }
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      // alert('Failed to update cart. Please try again.');
    });
}

// Helper: Map your bundle product IDs to Shopify variant IDs
//   function getShopifyVariantId(bundleProductId) {
//     const variantMap = {
//       1: '12345678901234',
//       2: '23456789012345',
//       // ... map each bundle product to its actual Shopify variant ID
//     };
//     return variantMap[bundleProductId];
//   }

// Initialize app
init();  
 